import { extractTarFiles } from './extractTarFiles';
import { jsonFileToObj, setProofToSrcFile } from './setProofToSrcFile';

export const sortFilesOld = async (selectedFiles, files) => {
  let sortedFiles: FileList[] = [];
  let sortJsonToFirstIndex: any[] = [];
  let sortErrors: any[] = [];
  let rejectedFiles: any[] = [];

  //If JSON file is included in selectedFiles, put it at index 0.
  //If no JSON file -> else if.
  //If more than one JSON file dont allow.
  if (
    files &&
    files[0]?.file?.type === 'application/json' &&
    selectedFiles[0]?.type === 'application/json'
  ) {
    let error = {
      message: 'You can only upload one JSON file',
      code: 'PROOF_FORMAT',
    };

    sortErrors.push(error);
    return { sortedFiles, rejectedFiles, sortErrors };
  }

  // Check if there is one JSON file in the selected files
  const checkJsonFiles = (files) => {
    const fileArray = Array.from(files); // Convert FileList to an array
    const jsonCount = fileArray.filter((file) => file.type === 'application/json').length;

    if (jsonCount === 0) return false;
    if (jsonCount === 1) return true;

    return 'You can only upload one JSON file';
  };

  const checkTarFiles = (files) => {
    const fileArray = Array.from(files); // Convert FileList to an array
    const tarCount = fileArray.filter((file) => file.type === 'application/x-tar').length;

    if (tarCount === 0) return false;
    if (tarCount === 1) return true;

    return 'You can only upload one TAR file';
  };

  const jsonFileUploaded = checkJsonFiles(selectedFiles);
  const tarFileUploaded = checkTarFiles(selectedFiles);

  // If there's more than one TAR file
  if (tarFileUploaded !== true) {
    if (tarFileUploaded === 'You can only upload one TAR file') {
      const error = {
        message: tarFileUploaded,
        code: 'PROOF_FORMAT',
      };
      sortErrors.push(error);
      return { sortedFiles, rejectedFiles, sortErrors };
    }
  }

  if (jsonFileUploaded === true) {
    sortJsonToFirstIndex = [...selectedFiles].sort((a, b) => {
      return a.type === 'application/json' ? -1 : b.type === 'application/json' ? 1 : 0;
    });

    const jsonObject = await jsonFileToObj(sortJsonToFirstIndex[0]);

    // If we get error of Invalid JSON structure
    if (jsonObject.error !== '') {
      const invalidJSONError = {
        message: jsonObject.error,
        code: 'PROOF_FORMAT',
      };

      sortErrors.push(invalidJSONError);
    }

    if (sortErrors.length === 0) {
      //If only JSON file or more than one extra file, only upload JSON file.
      sortedFiles.push(jsonObject.srcFileWithProof);
    }

    //If JSON file and one more non-JSON file, upload it.
    if (selectedFiles.length === 2) {
      sortedFiles.push(sortJsonToFirstIndex[1]);
    }
  } else if (jsonFileUploaded === false)
    // If no JSON file, process TAR files or src files
    for (let i = 0; i < selectedFiles.length; i++) {
      if (selectedFiles[i].type === 'application/x-tar') {
        const extractedTarFiles = await extractTarFiles(selectedFiles[i]);
        const tarProofResponse = await setProofToSrcFile(extractedTarFiles);

        if (tarProofResponse.error !== '') {
          const invalidJSONError = {
            message: tarProofResponse.error,
            code: 'PROOF_FORMAT',
          };

          sortErrors.push(invalidJSONError);
        } else {
          sortedFiles.push(tarProofResponse.srcFileWithProof);
        }
      } else {
        sortedFiles.push(selectedFiles[i]);
      }
    }

  if (jsonFileUploaded === 'You can only upload one JSON file') {
    sortErrors.push({ message: jsonFileUploaded, code: 'PROOF_FORMAT' });
  }
  return { sortedFiles, rejectedFiles, sortErrors };
};

export const sortFiles = async (selectedFiles, files) => {
  let sortedFiles: FileList[] = [];
  let sortErrors: any[] = [];
  let rejectedFiles: any[] = [];

  for (let i = 0; i < selectedFiles.length; i++) {
    // console.log('Pushing selected files');

    sortedFiles.push(selectedFiles[i]);
  }

  return { sortedFiles, rejectedFiles, sortErrors };
};
